import { Country } from '@/models/country';

/**
 * `flag-icons` CSS class suffixes (`fi fi-{code}`), 4×3 assets.
 * FIFA / sheet codes that differ from ISO are aliased below.
 */
export const countryFlagIconCode: Record<Country, string> = {
  [Country.QA]: 'qa',
  [Country.GB_ENG]: 'gb-eng',
  [Country.AR]: 'ar',
  [Country.FR]: 'fr',
  [Country.ES]: 'es',
  [Country.BE]: 'be',
  [Country.BR]: 'br',
  [Country.PT]: 'pt',
  [Country.NL]: 'nl',
  [Country.US]: 'us',
  [Country.MX]: 'mx',
  [Country.DK]: 'dk',
  [Country.SN]: 'sn',
  [Country.IR]: 'ir',
  [Country.PL]: 'pl',
  [Country.TN]: 'tn',
  [Country.DE]: 'de',
  [Country.HR]: 'hr',
  [Country.CH]: 'ch',
  [Country.UY]: 'uy',
  [Country.JP]: 'jp',
  [Country.MA]: 'ma',
  [Country.RS]: 'rs',
  [Country.KR]: 'kr',
  [Country.EC]: 'ec',
  [Country.GB_WLS]: 'gb-wls',
  [Country.SA]: 'sa',
  [Country.AU]: 'au',
  [Country.CR]: 'cr',
  [Country.CA]: 'ca',
  [Country.CM]: 'cm',
  [Country.GH]: 'gh',
  [Country.NZ]: 'nz',
  [Country.SE]: 'se',
  [Country.NO]: 'no',
  [Country.IT]: 'it',
  [Country.CN]: 'cn',
  [Country.IE]: 'ie',
  [Country.CO]: 'co',
  [Country.VN]: 'vn',
  [Country.JM]: 'jm',
  [Country.NG]: 'ng',
  [Country.PH]: 'ph',
  [Country.ZA]: 'za',
  [Country.ZM]: 'zm',
  [Country.HT]: 'ht',
  [Country.PA]: 'pa',
  [Country.HU]: 'hu',
  [Country.TR]: 'tr',
  [Country.RO]: 'ro',
  [Country.AL]: 'al',
  [Country.AT]: 'at',
  [Country.GB_SCT]: 'gb-sct',
  [Country.SI]: 'si',
  [Country.SK]: 'sk',
  [Country.CZ]: 'cz',
  [Country.UA]: 'ua',
  [Country.GE]: 'ge',
  [Country.TBD]: 'xx',
  [Country.FI]: 'fi',
  [Country.IS]: 'is',
  [Country.ALG]: 'dz',
  [Country.CPV]: 'cv',
  [Country.CUW]: 'cw',
  [Country.EGY]: 'eg',
  [Country.CIV]: 'ci',
  [Country.JOR]: 'jo',
  [Country.PAR]: 'py',
  [Country.UZB]: 'uz',
  [Country.BIH]: 'ba',
  [Country.COD]: 'cd',
  [Country.IRQ]: 'iq',
};
